export const getFormattedCommentWithMention = (comment: string) =>
  comment.replace(/\[@doctorName=[^\]]+\]/g, '');
